module.exports = __webpack_public_path__ + "static/media/floor-plan.36f0e7f2.webp";